import { LinkTracking } from '../context/tracking';
import { track } from '../track/track';

interface Payload extends LinkTracking {
  id: string;
  date?: 'true' | 'false';
  name?: string;
  filename?: string;
  onTrack?: () => void;
}

export const trackContentCard = ({ id, date, name, filename, linkType, linkHref, onTrack }: Payload): void => {
  track(
    'event.contentCard',
    { id, date: date ? 'true' : 'false', name, filename, linkType, linkHref },
    { callback: onTrack, once: false }
  );
};
